import { ApiError, TrackingDataListItem, TrackingV2Service } from '@api'
import { createEffect, createStore } from 'effector'

import { handleError } from '@/utils/error.ts'
import { dateToString } from '@/utils/helpers.ts'

// Tracking Activity States (single creator)
export const fetchTrackingActivityStatesFx = createEffect<
  {
    creatorId: number
    from: Date
    to: Date
  },
  Awaited<ReturnType<typeof TrackingV2Service.findTrackingDataByCreator>>,
  ApiError
>({
  name: 'fetch chatter tracking activity states',
  handler: async ({ creatorId, from, to }) => {
    return await TrackingV2Service.findTrackingDataByCreator({
      creatorId,
      from: dateToString(from),
      to: dateToString(to),
    })
  },
})

fetchTrackingActivityStatesFx.failData.watch((error) => {
  handleError(error, 'Failed to fetch chatter tracking activity states')
})

export const $trackingActivityStates = createStore<
  TrackingDataListItem[] | null
>(null).on(fetchTrackingActivityStatesFx.doneData, (_, data) => data.dataList)

export const $isTrackingActivityLoading = createStore<boolean>(false)
  .on(fetchTrackingActivityStatesFx, () => true)
  .on(fetchTrackingActivityStatesFx.finally, () => false)
